import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNotIn',
    standalone: false
})
export class IsNotInPipe implements PipeTransform {
  transform<T>(value: T, arr: Array<T>): boolean {
    return !arr.includes(value);
  }
}
